import { apiClient } from './authService';

const auditLogService = {
  getObjectHistory: async ({ appLabel, model, objectId, page = 1, pageSize = 20 } = {}) => {
    const params = new URLSearchParams();
    if (appLabel) params.set('app_label', appLabel);
    if (model) params.set('model', model);
    if (objectId) params.set('object_id', objectId);
    if (page) params.set('page', page);
    if (pageSize) params.set('page_size', pageSize);

    const response = await apiClient.get(`/audit-logs/?${params.toString()}`);
    return response.data;
  },
};

export default auditLogService;
